/* eslint-disable @typescript-eslint/no-explicit-any */
import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { initializeApp } from '@firebase/app';
import { getMessaging, getToken, onMessage } from '@firebase/messaging';
import { Router, NavigationEnd } from '@angular/router';
import { environment } from 'src/environments/environment';
import { filter } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { AuthService } from '../services/auth.service';

initializeApp(environment.firebaseConfig);
const messaging = getMessaging();
@Injectable({
  providedIn: 'root'
})
export class ServiceWorkerRegister {
  message: any = null;
  private currentUrl = '';

  constructor(
    private AuthService: AuthService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: any
  ) {
    // Track current route
    if (isPlatformBrowser(this.platformId)) {
      this.currentUrl = this.router.url;
      this.router.events
        .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          this.currentUrl = event.urlAfterRedirects;
        });
    }
  }

  publicApi(key: string = environment.firebaseConfig.apiKey): void {
    if (isPlatformBrowser(this.platformId)) {
      // eslint-disable-next-line prefer-const
      if (document.readyState === 'complete' || document.readyState === 'interactive') {
        this.registerServiceWorker();
      } else {
        // Otherwise wait for load event
        window.addEventListener('load', () => {
          this.registerServiceWorker();
        });
      }
    }
  }

  private registerServiceWorker(): void {
    if ('serviceWorker' in navigator) {
      const path = environment.path;
      const scope = environment.scope;

      navigator.serviceWorker
        .register(path, { scope })
        .then(registration => {
          // Only request permission if not on cms-info page
          if (!this.shouldSkipNotifications()) {
            this.requestPermission(registration);
          }
          this.listen();
        });
    }
  }

  private shouldSkipNotifications(): boolean {
    // Skip notification permissions for cms-info pages
    return this.currentUrl.includes('cms/privacyPolicyUserInfo');
  }

  requestPermission(sw: any): void {
    getToken(messaging, {
      vapidKey: environment.firebaseConfig.vapidKey,
      serviceWorkerRegistration: sw
    }).then((currentToken: any) => {
      if (currentToken) {
        console.log('currentToken', currentToken);
        this.AuthService.FCMtoken.next(currentToken);
      }
    });
  }
  listen(): void {
    onMessage(messaging, (payload: any) => {
      // Extract the product image and name from the push notification payload
      const productImage = payload.data.productImage;
      const productName = payload.data.productName;

      const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        timerProgressBar: true,
        showCancelButton: false,
        showCloseButton: true,
        showConfirmButton: false,
        timer: 100000,
        padding: '2rem',
        customClass: 'swal-wide noti_modal'
      });

      // Create an HTML element for the product image and name
      const content = document.createElement('div');

      // Create an image element
      const image = document.createElement('img');
      image.src = productImage;
      image.alt = productName;
      content.appendChild(image);

      // Create a paragraph element for the product name
      const name = document.createElement('p');
      name.textContent = productName;
      content.appendChild(name);

      // Display the toast notification with the custom content
      // Toast.fire({
      //   title: payload.notification.title
      //   // html: content
      // });

      // Add a click event listener to the toast container
      const toastContainer = document.querySelector('.swal2-container');
      toastContainer?.addEventListener('click', event => {
        const target = event.target as Element;
        if (target.classList.contains('swal2-close')) {
          // User clicked the close button, close the toast
          Swal.close();
        } else {
          // User clicked anywhere else, perform the redirection
          // window.location.href = `http://localhost:4200/account/currentorderpage?id=${payload.data.bookingId}`;
        }
      });

      // Optionally assign the payload to a variable for further use
      this.message = payload;
    });
  }
}
